import styled from "styled-components";

export const Button = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100%;
  padding: 0 ${({ theme }) => theme.space["space-4"]};
  height: 42px;
  background-color: ${({ theme }) => theme.colorTokens.component.input.surface};
  border: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  box-shadow: 0 1px 3px rgb(17 43 68 / 12%);
  border-radius: 2px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colorTokens.component.input.hover};
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  flex-grow: 1;
  pointer-events: none;
  min-width: 0;
`;
